import React from 'react';
import DatePicker from 'material-ui/DatePicker'
import TimePicker from 'material-ui/TimePicker'
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import { updateObject } from 'helpers/objectHelpers';
import { withState, compose } from 'recompose'
import SubmitModal from 'components/modals/SubmitModal'
import withSnackBar from 'store/snackbar/withSnackBar'
import { Label } from 'semantic-ui-react'
import styled from 'styled-components'
import FormSelect from './bases/FormSelect';

const ErrorLabel = styled(Label)`
  position: absolute !important;
  margin-top: 0 !important;
  z-index: 10 !important;
  margin-left: -65px !important;
  margin-right: -65px !important;
  left: -12% !important;
  font-size: 14px !important;
`

const styles = {
  wrapper: {
    display: 'flex',
    width: '100%',
    marginTop: '-10px',
    marginBottom: '10px',
  },
  pageWrapper: {
    display: 'flex',
    width: '40%',
  },
  dateWrapper: {
    display: 'flex',
    width: '60%',
  },
  startWrapper: {
    display: 'flex',
    width: '50%',
  },
  endWrapper: {
    display: 'flex',
    width: '50%',
  },
  deleteButton: {
    width: '5%',
  },
  formLink: {
    width: '20%',
    marginRight: 20,
    marginTop: 0,
    paddingRight: '10px',
    borderRight: 'solid 1px lightgrey',
  },
  formSelect: {
    width: '100%',
    marginTop: 0,
  },
  date: {
    width: '50%',
    paddingLeft: 5,
    paddingRight: 5,
  },
  time: {
    width: '50%',
    paddingLeft: 5,
    paddingRight: 30,
    position: 'relative',
  },
  inlineDateTime: {
    width: '100%',
  },
  button: {
    paddingTop: 25,
    paddingLeft: 40,
  },
};

const FormPageSchedule = compose(
  withSnackBar,
  withState('openModal', 'setOpenModal', false),
  withState('openStartError', 'setStartError', false),
  withState('openEndError', 'setEndError', false),
)(({
  schedule,
  pages,
  isEditing,
  setEditing,
  onRemove,
  handlePageScheduleChange,
  openModal,
  openStartError,
  openEndError,
  setOpenModal,
  setStartError,
  setEndError,
  index,
  hasEnd,
  hideError,
}) => {
  const MAX_DATE = 8640000000000000
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const getformatedDate = (date) => (
    `${date.getDate()}/${months[date.getMonth()]}/${date.getFullYear().toString().substr(-2)}`
  )
  const startDate = schedule.start && new Date(schedule.start)
  const endDate = schedule.end && new Date(schedule.end)
  const updateSchedule = ({ value, key }) => {
    handlePageScheduleChange(updateObject(schedule, { [key]: value }))
  }
  const updateStart = (value) => {
    if (hasEnd) {
      if (schedule.end && value > schedule.end) {
        const newEndDate = new Date(value)
        newEndDate.setHours(newEndDate.getHours() + 1)
        handlePageScheduleChange(updateObject(schedule, { start: value, end: newEndDate.getTime() }))
      } else {
        handlePageScheduleChange(updateObject(schedule, { start: value }))
      }
    } else {
      handlePageScheduleChange(updateObject(schedule, { start: value, end: MAX_DATE }))
    }
  }
  const updateEnd = (value) => {
    if (schedule.start && value < schedule.start) {
      setEndError(true)
      setTimeout(() => { setEndError(false) }, 3000);
      handlePageScheduleChange(updateObject(schedule, { end: schedule.start }))
    } else {
      handlePageScheduleChange(updateObject(schedule, { end: value }))
    }
  }

  const setDate = ({ date, value }) => {
    let newDate = date
    if (!newDate) {
      newDate = new Date(1, 1, 1, 0, 0, 0, 0)
    }
    newDate.setFullYear(value.getFullYear())
    newDate.setMonth(value.getMonth())
    newDate.setDate(value.getDate())
    return newDate
  }

  const setTime = ({ date = new Date(), value }) => {
    const newDate = date
    newDate.setHours(value.getHours())
    newDate.setMinutes(value.getMinutes())
    return newDate
  }

  return (
    <div style={styles.wrapper}>
      <div style={styles.deleteButton}>
        { (index !== 0) &&
          <IconButton
            onTouchTap={() => {
              setOpenModal(true)
            }}
          >
            <FontIcon
              className="fa fa-minus-circle"
              color="red"
            />
          </IconButton>
        }
      </div>
      <SubmitModal
        open={openModal}
        deleteContent={'link'}
        onClose={() => { setOpenModal(false) }}
        onSubmit={() => {
          onRemove()
          setEditing(true)
          setOpenModal(false)
          hideError()
        }}
      />
      <div style={styles.dateWrapper}>
        <div style={styles.startWrapper}>
          <DatePicker
            hintText="Start Date"
            disabled={!isEditing}
            value={startDate}
            formatDate={(date) => (getformatedDate(date))}
            onChange={(event, value) => {
              const start = setDate({ date: startDate, value })
              updateStart(start.getTime())
              hideError()
            }}
            style={styles.date}
            textFieldStyle={styles.inlineDateTime}
          />
          <div style={styles.time}>
            <TimePicker
              hintText="Start Time"
              disabled={!isEditing}
              value={startDate}
              onChange={(event, value) => {
                const start = setTime({ date: startDate, value })
                updateStart(start.getTime())
                hideError()
              }}
              textFieldStyle={styles.inlineDateTime}
            />
            { openStartError &&
              <ErrorLabel pointing color="red">Start time must less than end time</ErrorLabel> }
          </div>
        </div>
        { hasEnd &&
          <div style={styles.endWrapper}>
            <DatePicker
              hintText="End Date"
              disabled={!isEditing}
              value={endDate}
              minDate={startDate}
              formatDate={(date) => (getformatedDate(date))}
              onChange={(event, value) => {
                const start = setDate({ date: endDate, value })
                updateEnd(start.getTime())
                hideError()
              }}
              style={styles.date}
              textFieldStyle={styles.inlineDateTime}
            />
            <div style={styles.time}>
              <TimePicker
                hintText="End Time"
                disabled={!isEditing}
                value={endDate}
                onChange={(event, value) => {
                  const start = setTime({ date: endDate, value })
                  updateEnd(start.getTime())
                  hideError()
                }}
                textFieldStyle={styles.inlineDateTime}
              />
              { openEndError &&
                <ErrorLabel pointing color="red">End time must more than start time</ErrorLabel> }
            </div>
          </div>
        }
      </div>
      <div style={styles.pageWrapper}>
        <FormSelect
          disabled={!isEditing}
          value={schedule.pageId}
          onChange={(value) => {
            updateSchedule({ value, key: 'pageId' })
            hideError()
          }}
          options={pages}
          style={styles.formSelect}
        />
      </div>
    </div>
  );
});

FormPageSchedule.propTypes = {};
FormPageSchedule.defaultProps = {
  schedule: [],
  pages: [],
  onChange: () => {},
};

export default FormPageSchedule;



// WEBPACK FOOTER //
// ./src/components/forms/FormPageSchedule.js